<div class="w-full rounded-xl" [class.bg-white]="!mixedMode()" [class.dark:bg-surface-0]="!mixedMode()"
  [class.p-6]="!mixedMode()" [class.card-bg]="!mixedMode()">
  @if (!mixedMode()) {
  <div class="mb-8">
    <div class="flex items-center justify-between mb-6 flex-wrap gap-4">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Growth, Activation & Revenue</h1>
      <div class="flex items-center gap-3 flex-wrap">
        <app-date-picker [value]="datePickerValue" (dateRangeChange)="onDateRangeChange($event)"
          [showComparison]="false" [showGroupBy]="shouldShowGroupBy" size="sm">
        </app-date-picker>
        <button type="button" (click)="openCustomizeLayout()"
          class="customize-layout-btn flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="7" height="7" x="3" y="3" rx="1" />
            <rect width="7" height="7" x="14" y="3" rx="1" />
            <rect width="7" height="7" x="14" y="14" rx="1" />
            <rect width="7" height="7" x="3" y="14" rx="1" />
          </svg>
          Customize layout
        </button>
      </div>
    </div>
  </div>
  }

  <ng-template #sectionPin let-sectionId>
    @if (!mixedMode()) {
    <button type="button" (click)="togglePinToCustomDashboard(sectionId); $event.stopPropagation()"
      [disabled]="isAddingToCustomDashboard(sectionId)"
      class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
      [ngClass]="isAddedToCustomDashboard(sectionId)
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 !opacity-100 !translate-y-0'
            : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 dark:bg-slate-800/95 dark:border-purple-500/40'"
      [title]="isAddedToCustomDashboard(sectionId) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
      @if (isAddingToCustomDashboard(sectionId)) {
      <svg class="animate-spin shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span>{{ isAddedToCustomDashboard(sectionId) ? 'Removing' : 'Adding' }}&hellip;</span>
      } @else if (isAddedToCustomDashboard(sectionId)) {
      <!-- Pinned state: compact green check at rest so the card title
               stays fully visible. Hovering morphs the pill open and flips
               the affordance to a remove minus + label. -->
      <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M20 6 9 17l-5-5" />
      </svg>
      <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M5 12h14" />
      </svg>
      <span
        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
        from Custom Dashboard</span>
      } @else {
      <!-- Not-pinned state: pill hidden at card-rest. On card hover it
               fades in as a compact "+" icon. Hovering the icon then morphs
               the pill open to reveal the label, so the card title is never
               obscured at rest. -->
      <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14" />
        <path d="M12 5v14" />
      </svg>
      <span
        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
        to Custom Dashboard</span>
      }
    </button>
    }
  </ng-template>

  <div class="grid grid-cols-12 gap-6 grid-flow-row-dense">

    @if (showSection(SectionId.STAT_CARDS)) {
    <div class="relative group" [ngClass]="getSectionColClass(SectionId.STAT_CARDS)"
      [style.order]="sectionOrder(SectionId.STAT_CARDS)">
      <div
        class="bg-white dark:bg-surface-2 rounded-xl border border-gray-200 dark:border-gray-700 p-4 shadow-sm relative overflow-hidden h-auto">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.STAT_CARDS }"></ng-container>
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 2xl:gap-4">
          @for (card of statCards; track card.title) {
          <div
            class="bg-slate-50/90 dark:bg-surface-2 rounded-lg p-3 2xl:p-4 border border-gray-100 dark:border-gray-600/60 relative min-h-[60px] 2xl:min-h-[90px]">
            @if(isLoading) {
            <div class="absolute inset-0 flex items-center justify-center">
              <app-icon name="loader" [size]="24" class="animate-spin text-purple-500"></app-icon>
            </div>
            } @else {
            <div class="flex items-start gap-2 2xl:gap-3">
              <div
                [class]="'w-9 h-9 2xl:w-10 2xl:h-10 rounded-lg flex items-center justify-center shrink-0 ' + card.bgClass">
                <app-icon [name]="card.icon" [size]="18" [class]="card.iconColorClass + ' 2xl:w-5 2xl:h-5'" />
              </div>
              <div class="flex-1 min-w-0">
                <app-tooltip [width]="'max-content'" [className]="'text-center'" [content]="card.title" [block]="true">
                  <div class="text-start text-xs text-gray-500 dark:text-gray-400 mb-0.5 2xl:mb-1 truncate">{{
                    card.title }}</div>
                </app-tooltip>
                <div class="text-xl 2xl:text-[22px] font-bold text-gray-900 dark:text-white">{{ card.value | number :
                  (card.numberFormat || '1.0-0') }}</div>
              </div>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
    }

    @if (showSection(SectionId.KEY_INSIGHTS)) {
    <div [ngClass]="[getSectionColClass(SectionId.KEY_INSIGHTS), sectionShellHeightClass(SectionId.KEY_INSIGHTS)]"
      [style.order]="sectionOrder(SectionId.KEY_INSIGHTS)"
      class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 h-full flex flex-col relative group">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.KEY_INSIGHTS }"></ng-container>
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-3">Key Insights</h3>
      <div class="min-h-[180px] overflow-auto">
        <div class="space-y-3">
          @if(isLoading) {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
          } @else if(keyInsights.length > 0) {
          @for(insight of (showAllInsights ? keyInsights : keyInsights.slice(0, 7)); track $index) {
          <div class="flex items-center gap-2">
            <span class="text-purple-500 mt-1">•</span>
            <p class="text-sm text-gray-700 dark:text-gray-300">{{ insight }}</p>
          </div>
          }
          } @else {
          <div class="flex flex-col items-center justify-center py-8 text-gray-500">
            <p class="text-sm">No insights available for this period</p>
          </div>
          }
        </div>
        @if(keyInsights.length > 7) {
        <button class="mt-4 text-sm text-purple-600 dark:text-purple-400 hover:underline cursor-pointer"
          (click)="toggleInsights()">
          View all insights...
        </button>
        }
      </div>
    </div>
    }

    @if (showSection(SectionId.DROPOFF_COMPARISON)) {
    <div
      [ngClass]="[getSectionColClass(SectionId.DROPOFF_COMPARISON), sectionShellHeightClass(SectionId.DROPOFF_COMPARISON)]"
      [style.order]="sectionOrder(SectionId.DROPOFF_COMPARISON)"
      class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 h-full flex flex-col relative group">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.DROPOFF_COMPARISON }"></ng-container>
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Drop-off Comparison Across User Journeys
        </h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">Onboarding, simulator conversion, and support
          engagement gaps</p>
      </div>

      <div class="flex-1 min-h-[120px] w-full relative flex flex-col justify-center">
        @if(isLoading) {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
        } @else if(dropoffComparisonData.length > 0) {
        <app-data-progress-bar [data]="dropoffComparisonData" [showBorders]="true"
          [heightClass]="'!h-2'"></app-data-progress-bar>
        } @else {
        <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
          <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
          <p class="text-lg font-medium">No data available</p>
          <p class="text-sm mt-1">Data will appear here when available</p>
        </div>
        }
      </div>
    </div>
    }

    @if (showSection(SectionId.ONBOARDING_FUNNEL)) {
    <div [ngClass]="getSectionColClass(SectionId.ONBOARDING_FUNNEL)"
      [style.order]="sectionOrder(SectionId.ONBOARDING_FUNNEL)"
      class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 relative group">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.ONBOARDING_FUNNEL }"></ng-container>
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Onboarding Funnel</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Step-by-step conversion through onboarding process</p>
      </div>
      <div class="overflow-visible relative">
        @if(isLoading) {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
        } @else if(onboardingFunnelData.length > 0) {
        <app-funnel-chart [data]="onboardingFunnelData" [height]="'220px'" [min_height]="'220px'" [width]="'100%'"
          [showBorder]="false" [showShadow]="false" [showLegends]="false"
          [margins]="{ top: 20, right: 135, bottom: 0, left: 105 }" [padding]="'20px 0'"
          [darkThemeClass]="'dark:bg-surface-2'" [config]="{ title: '', barStyle: 'gradient' }">
        </app-funnel-chart>
        } @else {
        <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
          <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
          <p class="text-lg font-medium">No data available</p>
          <p class="text-sm mt-1">Data will appear here when available</p>
        </div>
        }
      </div>
    </div>
    }

    @if (showSection(SectionId.REVENUE_CONTRIBUTION)) {
    <div [ngClass]="getSectionColClass(SectionId.REVENUE_CONTRIBUTION)"
      [style.order]="sectionOrder(SectionId.REVENUE_CONTRIBUTION)"
      class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 flex flex-col relative group">
      <ng-container
        *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.REVENUE_CONTRIBUTION }"></ng-container>
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Revenue Contribution by Plan</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Comparison of total revenue generated across payment plans
        </p>
      </div>
      <div class="min-h-0 w-full overflow-hidden">
        @if(isLoading) {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
        } @else if(revenueContributionData.length > 0) {
        <app-single-bar class="w-full h-full block" [data1]="revenueContributionData" [valueKey]="'revenue'"
          [showBarValue]="true" [barWidthScale]="0.8" [chartHeight]="30" [minHeight]="250" [marginTop]="0"
          [marginBottom]="20" [marginLeft]="60" [barStyle]="'gradient'" [direction]="'top-to-bottom'">
        </app-single-bar>
        } @else {
        <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
          <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
          <p class="text-lg font-medium">No data available</p>
          <p class="text-sm mt-1">Data will appear here when available</p>
        </div>
        }
      </div>
    </div>
    }

    <!-- Key Insights Modal -->
    @if(showInsightsModal) {
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <!-- Backdrop with Glassmorphism -->
      <div class="absolute inset-0 bg-white/10 dark:bg-black/20 backdrop-blur-xs cursor-pointer"
        (click)="closeInsightsModal()"></div>

      <!-- Modal Content -->
      <div
        class="relative z-10 bg-white dark:bg-surface-2 backdrop-blur-xs rounded-2xl shadow-[0_0_100px_rgba(0,0,0,0.5)] w-full max-w-2xl flex flex-col overflow-hidden border border-gray-200 dark:border-gray-700">

        <!-- Header -->
        <div class="flex items-center justify-between p-4 border-b border-gray-100 dark:border-gray-700/50">
          <h3 class="text-xl font-bold text-gray-900 dark:text-white">Key Insights</h3>
          <button class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-line transition-colors cursor-pointer"
            (click)="closeInsightsModal()">
            <app-icon name="x" [size]="20" class="text-gray-500 dark:text-gray-400"></app-icon>
          </button>
        </div>

        <!-- Body (Scrollable) -->
        <div class="flex-1 overflow-y-auto p-4">
          <div class="">
            @for(insight of keyInsights; track $index) {
            <div class="flex items-center gap-3">
              <span class="text-gray-400 mt-1 shrink-0">•</span>
              <p class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">{{ insight }}</p>
            </div>
            }
          </div>
        </div>

      </div>
    </div>
    }

    @if (showSection(SectionId.CBC_EFFECT) || showSection(SectionId.PAYMENT_METHOD) ||
    showSection(SectionId.SIMULATOR_USAGE)) {
    <div class="col-span-12" [ngClass]="cbcPaymentRowGridClass()"
      [style.order]="rowDisplayOrder([SectionId.CBC_EFFECT, SectionId.PAYMENT_METHOD, SectionId.SIMULATOR_USAGE])">

      @if (showSection(SectionId.CBC_EFFECT)) {
      <div
        class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 h-full relative group">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.CBC_EFFECT }"></ng-container>
        <div>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">CBC Filled vs Credit Fetch Outcomes</h3>
          <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">Volume comparison across post-CBC stages</p>
        </div>
        <div class="h-full min-h-[300px] overflow-visible relative">
          @if(isLoading) {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
          } @else if(cbcEffectData.length > 0) {
          <app-horizontal-bar-chart [data]="cbcEffectData" [showYAxisGrid]="true" [showXAxisGrid]="true"
            [showXAxisLabel]="true" [showBarsValue]="true" [barHeight]="20" [barThickness]="15" [minHeight]="300"
            [barPadding]="10" [showBarsValue]="true" [marginTop]="20" [marginBottom]="20" [showLegend]="true">
          </app-horizontal-bar-chart>
          } @else {
          <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
            <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
            <p class="text-lg font-medium">No data available</p>
            <p class="text-sm mt-1">Data will appear here when available</p>
          </div>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.PAYMENT_METHOD) || showSection(SectionId.SIMULATOR_USAGE)) {
      <div class="grid grid-cols-1 gap-4" [ngClass]="mixedMode() ? 'h-full' : 'content-start'">
        @if (showSection(SectionId.PAYMENT_METHOD)) {
        <div class="flex flex-col justify-start bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 relative group" [class.h-full]="mixedMode()">
          <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PAYMENT_METHOD }"></ng-container>
          <div>
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Payment Method Distribution</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">Breakdown of payment types used</p>
          </div>
          <div class="min-h-0 w-full flex items-center justify-start relative">
            @if(isLoading) {
            <ng-container *ngTemplateOutlet="loader"></ng-container>
            } @else if(paymentMethodData.length > 0) {
            <div class="flex items-center w-full gap-4">
              <div class="relative shrink-0">
                <app-donut-chart [data]="paymentMethodData" [width]="160" [height]="160" [showLegend]="false"
                  [showValue]="false" [variant]="'concentric'" [translateX]="0" [translateY]="0" [radiusScale]="0.9"
                  [innerRadiusRatio]="0.3" [outerRadiusRatio]="1">
                </app-donut-chart>
              </div>

              <div class="flex flex-col gap-y-4 w-full min-w-0">
                @for(item of paymentMethodData; track item.label) {
                <div class="flex items-start gap-3">
                  <div class="w-1.5 h-8 rounded-full shrink-0 mt-0.5" [style.background-color]="item.color"></div>
                  <div class="flex flex-col">
                    <div class="text-sm font-semibold text-gray-900 dark:text-white leading-none mb-1">
                      {{ item.label }}: {{ item.value }}
                    </div>
                    <div class="text-xs text-gray-500 dark:text-gray-400">
                      {{ (item.value / paymentMethodTotal) | percent:'1.1-1' }} of total
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            } @else {
            <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
              <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
              <p class="text-lg font-medium">No data available</p>
              <p class="text-sm mt-1">Data will appear here when available</p>
            </div>
            }
          </div>
        </div>
        }

        @if (showSection(SectionId.SIMULATOR_USAGE)) {
        <div class="flex flex-col justify-start bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 relative group" [class.h-full]="mixedMode()">
          <ng-container
            *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.SIMULATOR_USAGE }"></ng-container>
          <div>
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Simulator Usage Distribution</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">Overall breakdown of simulator outcomes</p>
          </div>
          <div class="min-h-0 w-full flex items-center justify-start relative">
            @if(isLoading) {
            <ng-container *ngTemplateOutlet="loader"></ng-container>
            } @else if(simulatorUsageData.length > 0) {
            <app-donut-chart [data]="simulatorUsageData" [width]="simulatorLegendPosition == 'bottom' ? 180 : 300"
              [height]="simulatorLegendPosition == 'bottom' ? 90 : 140" [showLegend]="true" [showValue]="false"
              [innerRadiusRatio]="0.4" [outerRadiusRatio]="0.7" [radiusScale]="0.9" [translateY]="0" [translateX]="0"
              [legendPosition]="simulatorLegendPosition" [variant]="'concentric'" [semiCircle]="true"
              [legendShape]="'circle'" [legendTextColor]="'black'" [roundedCaps]="false">
            </app-donut-chart>
            } @else {
            <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
              <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
              <p class="text-lg font-medium">No data available</p>
              <p class="text-sm mt-1">Data will appear here when available</p>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
    }

    @if (showSection(SectionId.MONTHLY_DISPUTES_CALLS)) {
    <div class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 relative group"
      [ngClass]="getSectionColClass(SectionId.MONTHLY_DISPUTES_CALLS)"
      [style.order]="sectionOrder(SectionId.MONTHLY_DISPUTES_CALLS)">
      <ng-container
        *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.MONTHLY_DISPUTES_CALLS }"></ng-container>
      <div class="text-center mb-3">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Monthly Disputes & Calls Trend</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Track support volume over time</p>
      </div>
      <div class="flex justify-center">
        <div class="h-[400px] w-full max-w-[95%]">
          @if(isLoading) {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
          } @else if(lineAreaSeries.length > 0) {
          <app-line-area-chart [series]="lineAreaSeries" [height]="350"
            [margins]="{ top: 30, right: 100, bottom: 50, left: 100 }" [curveType]="'monotoneX'"
            [dateUnit]="chartDateUnit" [useDualYAxis]="true" [leftAxisLabel]="'Disputes'" [rightAxisLabel]="'Calls'"
            [showPoints]="true" [xAxisPadding]="55" [maxBarWidth]="80" [showValueLabels]="true"
            [valueLabelPosition]="'center'" [legend]="{ show: true, position: 'bottom', align: 'center', itemGap: 20 }"
            [xAxis]="{ show: true, showGrid: true, showAxisLine: true, fontSize: 11 }"
            [yAxis]="{ show: true, showGrid: true, showAxisLine: true, gridStyle: 'dashed', fontSize: 11, tickCount: 6 }">
          </app-line-area-chart>
          } @else {
          <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
            <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
            <p class="text-lg font-medium">No data available</p>
            <p class="text-sm mt-1">Data will appear here when available</p>
          </div>
          }
        </div>
      </div>
    </div>
    }

    @if (showSection(SectionId.CALL_SOURCE)) {
    <div [ngClass]="getSectionColClass(SectionId.CALL_SOURCE)" [style.order]="sectionOrder(SectionId.CALL_SOURCE)"
      class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 relative group">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.CALL_SOURCE }"></ng-container>
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Call Source Distribution</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Where customers initiate calls from</p>
      </div>
      <div class="min-h-[300px]">
        @if(isLoading) {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
        } @else if(callSourceRadarData.length > 0) {
        <div class="w-full h-[300px] flex items-center justify-center">
          <app-radar-chart class="w-full h-full block" [data]="callSourceRadarData" [color]="'#F43F5E'" [levels]="4">
          </app-radar-chart>
        </div>

        <!-- Summary Cards -->
        <div class="grid grid-cols-2 gap-4">
          @for(card of summaryCards; track $index) {
          <div class="bg-gray-50 dark:bg-white/5 p-3 rounded-xl border border-gray-100 dark:border-gray-700/50">
            <div class="flex justify-between items-start mb-1">
              <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{ card.label }}</span>
              @if(card.isBadge) {
              <span
                class="text-[10px] font-medium text-emerald-500 bg-emerald-50 dark:bg-emerald-500/10 px-2 py-0.5 rounded-full">{{
                card.rightText }}</span>
              } @else {
              <span class="text-[10px] font-medium text-gray-500 dark:text-gray-400">{{ card.rightText }}</span>
              }
            </div>
            <div class="text-xl font-bold text-gray-900 dark:text-white">{{ card.value | number }}</div>
          </div>
          }
        </div>

        } @else {
        <div class="flex flex-col items-center justify-center h-[300px] py-12 text-gray-500">
          <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
          <p class="text-lg font-medium">No data available</p>
          <p class="text-sm mt-1">Data will appear here when available</p>
        </div>
        }
      </div>
    </div>
    }

    @if (showSection(SectionId.PLAN_LIFECYCLE)) {
    <div [ngClass]="getSectionColClass(SectionId.PLAN_LIFECYCLE)" [style.order]="sectionOrder(SectionId.PLAN_LIFECYCLE)"
      class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-200 dark:border-gray-700 relative group">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PLAN_LIFECYCLE }"></ng-container>
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Plan Lifecycle Status Distribution</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Active vs inactive plans across purchase outcomes</p>
      </div>
      <div class="overflow-auto">
        @if(isLoading) {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
        } @else if(planLifecycleData.length > 0) {
        <div class="flex flex-col items-center">
          <!-- Pie Chart -->
          <app-pie-chart [data]="planLifecyclePieData" [showLegend]="false" [width]="210" [height]="210"
            [showLabelsOnHover]="false" [class]="'mt-3'">
          </app-pie-chart>

          <!-- Custom Cards Grid -->
          <div class="grid grid-cols-2 gap-4 w-full mt-5">
            @for(item of planLifecycleData; track item.label) {
            <div
              class="bg-white dark:bg-surface-2 border border-gray-200 dark:border-gray-700/50 rounded-xl px-3 py-2 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow">
              <div class="flex items-center gap-2">
                <!-- Vertical Pill Color Indicator -->
                <div class="w-1 h-6 rounded-full" [style.background-color]="item.color"></div>
                <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{ item.label }}</span>
              </div>
              <span class="text-lg font-bold text-gray-900 dark:text-white">{{ item.count | number }}</span>
            </div>
            }
          </div>
        </div>
        } @else {
        <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
          <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
          <p class="text-lg font-medium">No data available</p>
          <p class="text-sm mt-1">Data will appear here when available</p>
        </div>
        }
      </div>
    </div>
    }

    @if (showSection(SectionId.PAGE_SESSION)) {
    <div class="bg-white dark:bg-surface-2 rounded-xl p-6 border border-gray-200 dark:border-gray-700 relative group"
      [ngClass]="getSectionColClass(SectionId.PAGE_SESSION)" [style.order]="sectionOrder(SectionId.PAGE_SESSION)">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PAGE_SESSION }"></ng-container>
      <div class="text-left mb-6">
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-1">Page Session Distribution (In Minutes)</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Comparison of total sessions across key pages</p>
      </div>
      <div class="min-h-[300px] overflow-visible relative">
        @if(isLoading) {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
        } @else if(pageSessionData.length > 0) {

        <div class="grid grid-cols-12 gap-8">
          <!-- Dot Chart -->
          <div class="col-span-12 lg:col-span-8 h-[350px]">
            <app-dot-chart [data]="pageSessionData" [scaleType]="'log'" [marginTop]="20" [marginBottom]="20"
              [marginLeft]="50" [marginRight]="20">
            </app-dot-chart>
          </div>

          <!-- Legend -->
          <div
            class="col-span-12 lg:col-span-4 flex flex-col justify-center bg-white dark:bg-surface-2 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700/50">
            @for (item of pageSessionData; track item.label) {
            <div class="flex items-center justify-between py-2 text-sm text-gray-700 dark:text-gray-300">
              <div class="flex items-center gap-3">
                <div class="w-2.5 h-2.5 rounded-full shrink-0" [style.background-color]="item.color"></div>
                <span class="font-medium whitespace-nowrap overflow-hidden text-ellipsis max-w-[140px]">{{item.label}}
                  -</span>
              </div>
              <span class="font-semibold text-gray-900 dark:text-white shrink-0">{{item.value}} mins</span>
            </div>
            }
          </div>
        </div>

        <!-- Summary Cards -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <!-- Card 1 -->
          <div
            class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-100 dark:border-gray-700/50 shadow-sm h-auto">
            <div class="flex justify-between items-start mb-1">
              <span class="text-xs font-medium text-gray-900 dark:text-white uppercase tracking-wide">Longest
                Session</span>
              <span class="text-xs font-medium text-gray-400">{{longestSessionPage}}</span>
            </div>
            <div class="text-base font-bold text-gray-900 dark:text-white mt-1">{{longestSession}}m</div>
          </div>

          <!-- Card 2 -->
          <div
            class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-100 dark:border-gray-700/50 shadow-sm h-auto">
            <div class="flex justify-between items-start mb-1">
              <span class="text-xs font-medium text-gray-900 dark:text-white uppercase tracking-wide">Total Time
                Spend</span>
              <span class="text-xs font-medium text-gray-400">{{longestSessionPage}}</span>
            </div>
            <div class="text-base font-bold text-gray-900 dark:text-white mt-1">{{totalTimeSpend}}m</div>
          </div>

          <!-- Card 3 -->
          <div
            class="bg-white dark:bg-surface-2 rounded-xl p-4 border border-gray-100 dark:border-gray-700/50 shadow-sm h-auto">
            <div class="flex justify-between items-start mb-1">
              <span class="text-xs font-medium text-gray-900 dark:text-white uppercase tracking-wide">Total Pages</span>
              <span class="text-xs font-medium text-gray-400">{{longestSessionPage}}</span>
            </div>
            <div class="text-base font-bold text-gray-900 dark:text-white mt-1">{{totalPages}}</div>
          </div>
        </div>

        } @else {
        <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
          <app-icon name="inbox" [size]="64" class="text-gray-300 mb-3"></app-icon>
          <p class="text-lg font-medium">No data available</p>
          <p class="text-sm mt-1">Data will appear here when available</p>
        </div>
        }
      </div>
    </div>
    }

  </div>
</div>

<app-dashboard-layout-editor [open]="isLayoutEditorOpen()" [items]="editorItems()" [visibleCount]="editorVisibleCount()"
  [isTallTile]="isLayoutEditorTallTile" (closed)="closeLayoutEditor()" (applied)="applyLayoutEditor()"
  (resetDefaults)="resetLayoutEditorToDefaults()" (cardDropped)="onEditorCardDrop($any($event))"
  (visibilityToggled)="toggleEditorCardVisibility($any($event))"
  (colSpanDecreased)="decreaseEditorCardColSpan($any($event))"
  (colSpanIncreased)="increaseEditorCardColSpan($any($event))" (autoAdjustWidth)="autoAdjustEditorWidths()" />

<ng-template #loader>
  <div class="h-full w-full flex items-center justify-center min-h-[200px]">
    <app-icon name="loader" [size]="40" class="animate-spin text-purple-500"></app-icon>
  </div>
</ng-template>